<template>
  <v-card outlined>
    <v-card-text class="black--text">
      <v-simple-table dense>
        <thead>
          <tr>
            <td style="width:600px"></td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="4"><strong>Required Tests</strong></td>
          </tr>
          <tr v-for="(test, index) in bill.tests" :key="index">
            <td class="pl-8">
              <strike v-if="test.disabled">
                {{test.name}}
              </strike>
              <span v-else>{{test.name}}</span>
            </td>
            <td>
              <strike v-if="test.disabled">
                ${{test.basePrice.toFixed(2)}}
              </strike>
              <span v-else>${{test.basePrice.toFixed(2)}}</span>
            </td>
            <td>
              <v-btn v-if="test.disabled" color="black" outlined @click="toggleDisableTestPrice(test)" small><v-icon>undo</v-icon></v-btn>
              <v-btn v-else color="error" @click="toggleDisableTestPrice(test)" small><v-icon>remove</v-icon></v-btn>
            </td>
          </tr>
          <tr>
            <td><strong>Base Total</strong></td>
            <td><strong>${{bill.basePrice.toFixed(2)}}</strong></td>
            <td></td>
          </tr>
          <tr v-if="bill.extra_costs.length > 0">
            <td colspan="3"><strong>Additions</strong></td>
          </tr>
          <tr v-if="bill.extra_costs.length > 0" v-for="(addition, index) in bill.extra_costs" :key="index+'addition'">
            <td class="pl-8">{{addition.name}}</td>
            <td>${{addition.additional_cost.toFixed(2)}}</td>
            <td>
<!--              <v-btn color="error" small><v-icon>remove</v-icon></v-btn>-->
            </td>
          </tr>
          <tr v-if="bill.discounts.length > 0">
            <td colspan="3"><strong>Discounts</strong></td>
          </tr>
          <tr v-if="bill.discounts.length > 0" v-for="(discount, index) in bill.discounts" :key="index+'discount'">
            <td class="pl-8">{{discount.name}}</td>
            <td>- ${{discount.discount.toFixed(2)}}</td>
            <td>
<!--              <v-btn color="error" small><v-icon>remove</v-icon></v-btn>-->
            </td>
          </tr>
          <tr v-if="bill.percentDiscount && !bill.subtotal">
            <td><strong>Percent Discount</strong></td>
            <td><strong>{{bill.percentDiscount}}</strong></td>
            <td></td>
          </tr>
          <tr v-if="bill.subtotal">
            <td><strong>Sub Total</strong></td>
            <td><strong>${{ bill.subtotal }}</strong></td>
          </tr>
          <tr v-if="bill.subtotal && bill.afterSubtotal.length > 0" v-for="(discount, index) in bill.afterSubtotal" :key="index+'subtotal'">
            <td>{{discount.name}}</td>
            <td>- ${{discount.discount}}</td>
          </tr>
          <tr v-if="bill.subtotal && bill.percentDiscount">
            <td>Percent Discount</td>
            <td>- {{bill.percentDiscount}}</td>
          </tr>
          <tr v-if="bill.afterSubtotal.length > 0">
            <td colspan="2">
              <v-divider></v-divider>
            </td>
          </tr>
          <tr>
            <td>
              <strong v-if="bill.finalPrice === bill.customPrice">Final Total</strong>
              <strike v-else>Final Total</strike>
            </td>
            <td>
              <strong v-if="bill.finalPrice === bill.customPrice">${{bill.finalPrice.toFixed(2)}}</strong>
              <strike v-else>${{bill.finalPrice.toFixed(2)}}</strike>
            </td>
            <td></td>
          </tr>
          <tr v-if="bill.customPrice !== bill.finalPrice">
            <td><strong>Custom Final Price</strong></td>
            <td><strong>${{parseFloat(bill.customPrice).toFixed(2)}}</strong></td>
            <td></td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
    name: "BillingSampleInvoice",
    components: {},
    props:{
      bill:{
        required: true,
      }
    },
    data: () => ({}),
    methods: {
      toggleDisableTestPrice(test){
        let find = this.bill.sample_tests.find(sampleTest => sampleTest.uuid === test.uuid)
        find.disabled = !find.disabled;
        test.disabled = find.disabled;
        console.log(this.bill)
        this.$emit('update_bill', this.bill)
      }
    }
}
</script>

<style scoped>

</style>
